/**
 * useResponsive — Breakpoint hook
 * mobile (<640) | tablet (640-1024) | desktop (1024-1920) | tv (>1920)
 */
import { useEffect, useState } from 'react'

export type Breakpoint = 'mobile' | 'tablet' | 'desktop' | 'tv'

function getBreakpoint(): Breakpoint {
  const w = window.innerWidth
  if (w < 640) return 'mobile'
  if (w < 1024) return 'tablet'
  if (w < 1920) return 'desktop'
  return 'tv'
}

export function useResponsive() {
  const [bp, setBp] = useState(getBreakpoint)

  useEffect(() => {
    const handler = () => setBp(getBreakpoint())
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return {
    bp,
    isMobile: bp === 'mobile',
    isTablet: bp === 'tablet',
    isDesktop: bp === 'desktop',
    isTV: bp === 'tv',
    isSmall: bp === 'mobile' || bp === 'tablet',
  }
}
